interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, totalPages: number): (number | string)[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  if (current > 3) pages.push("...");
  for (let p = Math.max(2, current - 1); p <= Math.min(totalPages - 1, current + 1); p += 1) {
    pages.push(p);
  }
  if (current < totalPages - 2) pages.push("...");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(current, totalPages);

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className="min-w-[44px] h-11 px-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer flex items-center justify-center"
      >
        <i className="ri-arrow-left-s-line text-lg" />
        <span className="hidden sm:inline ml-1">上一页</span>
      </button>

      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`min-w-[44px] h-11 px-3 rounded-md text-sm transition-colors cursor-pointer ${
              page === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`gap-${index}`} className="w-8 text-center text-foreground-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        disabled={current >= totalPages}
        onClick={() => onChange(current + 1)}
        className="min-w-[44px] h-11 px-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer flex items-center justify-center"
      >
        <span className="hidden sm:inline mr-1">下一页</span>
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}